import Spinner from "../../../shared/UxbiSpinner";
import { request, requestBlob } from "../../../api/http";
import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Form,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import AsyncSelectERP from "../../common/AsyncSelectERP";
import {
  getClientes,
  getAgentes,
  getProbabilidadesCierre,
  getOportunidades,
  getOportunidadesPerdidas,
  getTipoSeguimientos,
} from "../../../api/uxbi";
import { getCurrentUser } from "../../utils/getCurrentUser";
import WdowConfirm from "../../utils/WdowConfirm";
import { toast } from "react-toastify";
import { closingProbability } from '../../../modules/crm/seguimientoDefaults';

export default function SeguimientoFormModal({
  show,
  onHide,
  onSubmit,
  record,
  isEditMode = false,
}) {
  const today = new Date().toISOString().split("T")[0];
  const session = getCurrentUser();
  const initialState = {
    cliente: null,
    probabilidad: null,
    usuario: null,
    nombre: "",
    montoProyecto: "",
    fechaVencimiento: today,
    fechaTentativaCierre: "",
  };

  const [form, setForm] = useState(initialState);
  const [confirmModal, setConfirmModal] = useState({
    show: false,
    step: null,
    data: [],
    payload: null,
  });
  const [confirmModalDelFile, setConfirmModalDelFile] = useState({
    show: false,
    step: null,
    data: [],
    payload: null,
  });
  const [loading, setLoading] = useState(false);
  const [direccion, setDireccion] = useState(null);

  const styles = {
    overlay: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backdropFilter: "blur(4px)",
      backgroundColor: "rgba(255,255,255,0.6)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1055,
    },
    spinnerContainer: {
      textAlign: "center",
    },
  };

  const estatusConNext = [
    "Post-Entrevista",
    "Pre-Entrevista",
    "En reactivación",
    "Reactivado",
    "Post-venta",
    "En Tiempo",
  ];

  const reglas = {
    mostrarNext: estatusConNext.includes(form.estatus),
    mostrarGanado: form.estatus === "Ganado",
    mostrarPerdido: form.estatus === "Perdido",
    mostrarMotivoRetraso: form.estatus === "Perdido",
    mostrarOportunidadPerdida: form.estatus === "Perdido",
    mostrarCompartido: form.usuarioCompartido === true,
    mostrarFechaPromesa: form.estatus === "Seguimiento de cobranza",
  };

  const filtrosAgentes = [
    {
      relation: "roles",
      property: "name",
      value: "VEND",
      operator: "=",
    },
  ];

  useEffect(() => {
    if (!show) return;

    const init = async () => {
      // CREACIÓN
      if (!isEditMode) {
        const newForm = {
          ...initialState,
          usuario: {
            value: session.id,
            label: session.nombre,
          },
          nextUsuario: {
            value: session.id,
            label: session.nombre,
          },
        };

        if (record) {
          newForm.cliente = {
            value: record.cliente.id,
            label: record.cliente.nombre,
          };

          newForm.oportunidad = record.oportunidad
            ? {
                value: record.oportunidad.id,
                label: record.oportunidad.nombre,
                data: [record.oportunidad],
              }
            : null;
        }

        setForm(newForm);

        return;
      }

      // EDICIÓN
      if (isEditMode && record) {
        const oportunidad = record.oportunidad
          ? {
              value: record.oportunidad.id,
              label: record.oportunidad.nombre,
              data: [record.oportunidad],
            }
          : null;

        const cliente = record.cliente
          ? {
              value: record.cliente.id,
              label: record.cliente.nombre,
              data: [record.cliente],
            }
          : null;

        const usuarioCompartido = record.id_usuario_compartido > 0;

        const minuta = record.uploads?.length > 0 ? record.uploads[0] : null;

        const fpp =
          record.uploads?.length > 0
            ? record.uploads.find(
                (u) => (u.tipo || u.nombre_documento) === "FPP",
              )
            : null;

        setForm({
          fechaVencimiento: record.fecha_vencimiento || "",
          estatus: record.estatus || "",
          usuario: record.usuario
            ? {
                value: record.usuario.id,
                label: record.usuario.nombre,
              }
            : null,
          cliente,
          clienteInfo: record.cliente || null,
          seguimientoTipo: record.seguimiento_realizado
            ? {
                value: record.seguimiento_realizado.id,
                label: record.seguimiento_realizado.descripcion,
              }
            : null,
          oportunidad,
          probabilidad: closingProbability(record),
          notas: record.notas_seguimiento || "",
          oportunidadPerdida: record.oportunidad_perdida
            ? {
                value: record.oportunidad_perdida.id,
                label: record.oportunidad_perdida.descripcion,
              }
            : null,
          razonPerdida: record.razon_oportunidad_perdida || "",
          motivoRetraso: record.motivo_retraso || "",
          usuarioCompartido,
          usuarioCompartidoSelect: usuarioCompartido
            ? {
                value: record.id_usuario_compartido,
                label: record.usuario_compartido.nombre,
              }
            : null,
          nextUsuario: record.next_usuario
            ? {
                value: record.next_usuario.id,
                label: record.next_usuario.nombre,
              }
            : null,
          nextSeguimiento: record.next_seguimiento
            ? {
                value: record.next_seguimiento.id,
                label: record.next_seguimiento.descripcion,
              }
            : null,
          nextFecha: record.next_fecha_vencimiento || "",
          nextHora: record.next_hora || "",
          archivoMinutaNombre: minuta?.original_filename || null,
          archivoMinutaId: minuta?.id || null,
          archivoMinutaFilename: minuta?.filename || null,
          archivoFPPNombre: fpp?.original_filename || null,
          archivoFPPId: fpp?.id || null,
        });

        // Mostrar ubicación guardada si existe
        setDireccion(record.ubicacion || null);
      }
    };

    init();
  }, [show, record, isEditMode]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!form.cliente) return;

    // SOLO si el cliente cambió manualmente
    if (!isEditMode && !record) {
      setForm((prev) => ({
        ...prev,
        oportunidad: null,
      }));
    }

    setForm((prev) => ({
      ...prev,
      clienteInfo: form.cliente?.data?.[0] || null,
    }));
  }, [form.cliente]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!form.oportunidad?.value) {
      if (!isEditMode) {
        setForm((prev) => ({
          ...prev,
          probabilidad: null,
        }));
      }
      return;
    }

    // Sencha toma la probabilidad de la oportunidad también al ejecutar.
    {
      const data = form.oportunidad?.data?.[0];

      if (data?.probabilidad) {
        setForm((prev) => ({
          ...prev,
          probabilidad: {
            value: data.probabilidad.id,
            label: data.probabilidad.descripcion,
          },
        }));
      }
    }
  }, [form.oportunidad]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!form.usuarioCompartido) {
      setForm((prev) => ({
        ...prev,
        usuarioCompartidoSelect: null,
      }));
    }
  }, [form.usuarioCompartido]);

  useEffect(() => {
    if (!form.estatus) return;

    // PERDIDO
    if (form.estatus === "Perdido") {
      setForm((prev) => ({
        ...prev,
        nextUsuario: null,
        nextSeguimiento: null,
        nextFecha: null,
        nextHora: null,
      }));
    }

    // GANADO
    if (form.estatus === "Ganado") {
      setForm((prev) => ({
        ...prev,
        razonPerdida: null,
        oportunidadPerdida: null,
      }));
    }

    // ESTATUS CON NEXT
    if (estatusConNext.includes(form.estatus)) {
      if (!form.nextUsuario) {
        setForm((prev) => ({
          ...prev,
          nextUsuario: {
            value: session.id,
            label: session.nombre,
          },
        }));
      }
    }
  }, [form.estatus]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const fieldLabels = {
    usuario: "Usuario",
    cliente: "Cliente",
    fechaVencimiento: "Fecha de vencimiento",
  };

  const getRequiredFields = (isEditMode) => {
    return ["usuario", "cliente", "fechaVencimiento"];
  };

  const getMissingFields = (form, isEditMode) => {
    const missing = [];
    const requiredFields = getRequiredFields(isEditMode);

    requiredFields.forEach((field) => {
      const value = form[field];

      const isEmpty =
        value === undefined ||
        value === null ||
        value === "" ||
        (typeof value === "object" && !value.value && !value.length);

      if (isEmpty) {
        missing.push(field);
      }
    });

    return missing;
  };

  const uploadArchivo = async (actividadId, file, nombre, tipo) => {
    const body = new FormData();
    body.append("archivo", file);
    body.append("custom_name", nombre);
    body.append("tipo", tipo);
    body.append("nombre_documento", tipo);
    return request(`actividades/${actividadId}/upload-file`, {
      method: "POST",
      body,
    });
  };
  const openAttachment = async (upload) => {
    try {
      const b = await requestBlob(
        `comercial-app/actividades/${record.id}/archivo/${upload}`,
      );
      const url = URL.createObjectURL(b);
      const a = document.createElement("a");
      a.href = url;
      a.download = "adjunto";
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (e) {
      toast.error(e.message);
    }
  };

  async function handleSubmit() {
    const missingFields = getMissingFields(form, isEditMode);
    if (missingFields.length > 0) {
      toast.warning(
        <div>
          <strong>Faltan por completar los siguientes campos:</strong>
          <br />
          <br />
          {missingFields.map((field) => (
            <div key={field}>• {fieldLabels[field]}</div>
          ))}
        </div>,
        { autoClose: 6000 },
      );

      return;
    }

    setLoading(true);

    const payload = {
      id: record?.id ?? null,

      // Cliente
      id_cliente: form.cliente?.value,

      // Usuario
      id_usuario: form.usuario?.value,

      // Oportunidad
      id_oportunidad: form.oportunidad?.value || null,

      // Seguimiento realizado
      id_seguimiento_realizado: form.seguimientoTipo?.value || null,

      // Probabilidad
      id_probabilidad_cierre: form.probabilidad?.value || null,

      id_cxc: null, // No aplica pero backend lo espera

      // Fechas
      fecha_vencimiento: form.fechaVencimiento || null,
      fecha_promesa_pago: form.fechaPromesaPago || null,

      // Estatus
      estatus: form.estatus || null,

      // Tipo
      tipo_seguimiento: "CL",

      // Notas
      notas_seguimiento: form.notas || null,

      // Perdido
      id_oportunidad_perdida: form.oportunidadPerdida?.value || null,
      razon_oportunidad_perdida: form.razonPerdida || null,

      // Motivo retraso
      id_motivo_retraso: form.motivoRetraso || null,

      // Compartido
      id_usuario_compartido: form.usuarioCompartidoSelect?.value || null,

      // Ubicación
      ubicacion: direccion,

      // NEXT
      next_id_usuario: form.nextUsuario?.value || null,
      next_id_seguimiento_realizado: form.nextSeguimiento?.value || null,
      next_fecha_vencimiento: form.nextFecha || null,
      next_hora: form.nextHora || null,
    };

    try {
      if (isEditMode) {
        await onSubmit(payload);

        // UPLOAD MINUTA
        if (form.archivoMinuta) {
          await uploadArchivo(
            record?.id,
            form.archivoMinuta,
            form.archivoMinutaNombre,
            "Minuta",
          );
        }

        // UPLOAD FPP
        if (form.archivoFPP) {
          await uploadArchivo(
            record?.id,
            form.archivoFPP,
            form.archivoFPPNombre,
            "FPP",
          );
        }

        toast.success("Cambios guardados correctamente");

        setLoading(false);
        onHide();
        return;
      }

      setLoading(false);

      setConfirmModal({
        show: true,
        type: "confirmar",
        data: null,
        payload,
      });
    } catch (error) {
      setLoading(false);
      console.error(error);
      toast.error("Error al procesar la petición.");
      throw error;
    }
  }

  const handleFileChange = (field, file) => {
    if (!file) return;

    const name = file.name.split(".").slice(0, -1).join(".");

    setForm((prev) => ({
      ...prev,
      [field]: file,
      [`${field}Nombre`]: name,
    }));
  };

  async function handleDeleteFile(field) {
    setConfirmModalDelFile({
      show: true,
      type: "confirm",
      message: "¿Eliminar archivo?",
      payload: {
        field,
        archivoId: form.archivoMinutaId,
      },
    });
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      backdrop="static"
      keyboard={false}
      centered
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {isEditMode ? "EJECUTAR SEGUIMIENTO " : "NUEVO SEGUIMIENTO"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ position: "relative" }}>
        <Form>
          <Row>
            {/* Usuario */}
            <Col md={4}>
              <Form.Group>
                <Form.Label>Usuario</Form.Label>
                <AsyncSelectERP
                  value={form.usuario}
                  loadOptionsApi={getAgentes}
                  additionalFilters={filtrosAgentes}
                  onChange={(val) => handleChange("usuario", val)}
                />
              </Form.Group>
            </Col>

            {/* Cliente */}
            <Col md={4}>
              <Form.Group>
                <Form.Label>
                  Cliente / Prospecto
                  {form.clienteInfo && (
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="tooltip-cliente">
                          <div style={{ textAlign: "left" }}>
                            <div>
                              <strong>Clave:</strong> {form.clienteInfo.clave}
                            </div>
                            <div>
                              <strong>Contacto:</strong>{" "}
                              {form.clienteInfo.nombre_contacto}
                            </div>
                            <div>
                              <strong>Tel:</strong> {form.clienteInfo.telefono}
                            </div>
                            <div>
                              <strong>Email:</strong> {form.clienteInfo.email}
                            </div>
                          </div>
                        </Tooltip>
                      }
                    >
                      <img
                        src="/info.svg"
                        className="animate-pop ms-2 me-2"
                        alt="Info del cliente"
                        style={{ maxHeight: 25, cursor: "pointer" }}
                      />
                    </OverlayTrigger>
                  )}
                </Form.Label>
                <AsyncSelectERP
                  value={form.cliente}
                  loadOptionsApi={getClientes}
                  additionalFilters={
                    form.clienteInput
                      ? [
                          {
                            group: [
                              {
                                property: "alias_1",
                                value: form.clienteInput,
                                operator: "LIKE",
                              },
                              {
                                property: "nombre",
                                value: form.clienteInput,
                                operator: "LIKE",
                                condition: "OR",
                              },
                              {
                                property: "clave",
                                value: form.clienteInput,
                                operator: "LIKE",
                                condition: "OR",
                              },
                            ],
                            condition: "AND",
                          },
                        ]
                      : []
                  }
                  onInputChange={(input) => handleChange("clienteInput", input)}
                  onChange={(val) => handleChange("cliente", val)}
                  isDisabled={isEditMode}
                />
              </Form.Group>
            </Col>

            {/* Oportunidad */}
            <Col md={4}>
              <Form.Group>
                <Form.Label>Oportunidad</Form.Label>
                <AsyncSelectERP
                  value={form.oportunidad}
                  loadOptionsApi={getOportunidades}
                  additionalFilters={
                    form.cliente
                      ? [
                          {
                            property: "id_cliente",
                            value: form.cliente?.value ?? form.cliente,
                          },
                        ]
                      : []
                  }
                  additionalParams={{
                    perfil: "all",
                  }}
                  onChange={(val) => setForm(prev => ({ ...prev, oportunidad: val,
                    probabilidad: closingProbability({ oportunidad: val?.data?.[0] }) }))}
                  isDisabled={!form.cliente}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={4}>
              <Form.Group>
                <Form.Label>Fecha de Vencimiento</Form.Label>
                <Form.Control
                  type="date"
                  value={form.fechaVencimiento || ""}
                  onChange={(e) =>
                    handleChange("fechaVencimiento", e.target.value)
                  }
                  disabled={!isEditMode}
                />
              </Form.Group>
            </Col>
            {direccion?.length > 0 && (
              <span className="mt-2">Ubicacion: {direccion}</span>
            )}

            {reglas.mostrarFechaPromesa && (
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Fecha Promesa Pago</Form.Label>
                  <Form.Control
                    type="date"
                    value={form.fechaPromesaPago || ""}
                    onChange={(e) =>
                      handleChange("fechaPromesaPago", e.target.value)
                    }
                  />
                </Form.Group>
              </Col>
            )}
          </Row>
          {/* ARCHIVOS */}
          <Row className="mt-3">
            {/* MINUTA */}
            <Col md={4}>
              <Form.Group>
                <Form.Label>Minuta</Form.Label>

                {/* Botón personalizado */}
                <div className="d-flex gap-2">
                  <Button
                    variant="outline-primary"
                    onClick={() =>
                      document.getElementById("fileMinuta").click()
                    }
                  >
                    Seleccionar archivo
                  </Button>

                  <Form.Control
                    id="fileMinuta"
                    type="file"
                    style={{ display: "none" }}
                    onChange={(e) =>
                      handleFileChange("archivoMinuta", e.target.files[0])
                    }
                  />
                </div>
              </Form.Group>

              {/* Preview */}
              <div style={{ minHeight: 32 }}>
                {form.archivoMinutaNombre && (
                  <div className="d-flex align-items-center justify-content-between mt-2 border rounded p-2">
                    <small
                      className="text-muted text-truncate"
                      style={{ maxWidth: "65%" }}
                    >
                      {form.archivoMinutaNombre}
                    </small>

                    <div className="d-flex gap-1">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => {
                          if (form.archivoMinuta instanceof File) {
                            window.open(
                              URL.createObjectURL(form.archivoMinuta),
                            );
                          } else if (form.archivoMinutaId) {
                            openAttachment(form.archivoMinutaId);
                          }
                        }}
                      >
                        Ver
                      </Button>

                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => handleDeleteFile("archivoMinuta")}
                      >
                        ✕
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </Col>

            {/* FPP */}
            {reglas.mostrarFechaPromesa && (
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Evidencia FPP</Form.Label>

                  <div className="d-flex gap-2">
                    <Button
                      variant="outline-primary"
                      onClick={() => document.getElementById("fileFPP").click()}
                    >
                      Seleccionar archivo
                    </Button>

                    <Form.Control
                      id="fileFPP"
                      type="file"
                      style={{ display: "none" }}
                      onChange={(e) =>
                        handleFileChange("archivoFPP", e.target.files[0])
                      }
                    />
                  </div>
                </Form.Group>

                <div style={{ minHeight: 32 }}>
                  {form.archivoFPPNombre && (
                    <div className="d-flex align-items-center justify-content-between mt-2 border rounded p-2">
                      <small
                        className="text-muted text-truncate"
                        style={{ maxWidth: "65%" }}
                      >
                        {form.archivoFPPNombre}
                      </small>

                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => handleDeleteFile("archivoFPP")}
                      >
                        ✕
                      </Button>
                    </div>
                  )}
                </div>
              </Col>
            )}
          </Row>

          {/* COMPARTIDO */}
          <Row className="mt-3 align-items-end">
            <Col md={4}>
              <Form.Check
                type="checkbox"
                label="Seguimiento compartido"
                checked={form.usuarioCompartido || false}
                onChange={(e) =>
                  handleChange("usuarioCompartido", e.target.checked)
                }
              />
            </Col>

            {reglas.mostrarCompartido && (
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Compartido con</Form.Label>
                  <AsyncSelectERP
                    value={form.usuarioCompartidoSelect}
                    loadOptionsApi={getAgentes}
                    additionalFilters={filtrosAgentes}
                    onChange={(val) =>
                      handleChange("usuarioCompartidoSelect", val)
                    }
                  />
                </Form.Group>
              </Col>
            )}
          </Row>

          {/* ESTATUS */}
          <Row className="mt-3">
            <Col md={4}>
              <Form.Group>
                <Form.Label>Estatus</Form.Label>
                <Form.Select
                  value={form.estatus || ""}
                  onChange={(e) => handleChange("estatus", e.target.value)}
                >
                  <option value="">Seleccione</option>
                  <option>Post-Entrevista</option>
                  <option>Pre-Entrevista</option>
                  <option>En reactivación</option>
                  <option>Reactivado</option>
                  <option>Ganado</option>
                  <option>Perdido</option>
                  <option>Post-venta</option>
                  <option>Seguimiento de cobranza</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <Form.Label>Seguimiento Realizado</Form.Label>
                <AsyncSelectERP
                  value={form.seguimientoTipo}
                  loadOptionsApi={getTipoSeguimientos}
                  additionalFilters={[
                    {
                      property: "grupo_seguimiento",
                      value: "CL",
                    },
                  ]}
                  onChange={(val) => handleChange("seguimientoTipo", val)}
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <Form.Label>Probabilidad de cierre</Form.Label>
                <AsyncSelectERP
                  value={form.probabilidad}
                  loadOptionsApi={getProbabilidadesCierre}
                  onChange={(val) => handleChange("probabilidad", val)}
                />
              </Form.Group>
            </Col>

            {reglas.mostrarMotivoRetraso && (
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Motivo de Retraso</Form.Label>
                  <Form.Select
                    value={form.motivoRetraso || ""}
                    onChange={(e) =>
                      handleChange("motivoRetraso", e.target.value)
                    }
                  >
                    <option value="">Seleccione</option>
                    <option value="PS">Problema con Siniestro</option>
                    <option value="PAAC">Problema Área Comercial</option>
                    <option value="PF">Problema Factura</option>
                    <option value="PFE">Flujo Efectivo</option>
                    <option value="PSAO">Área Operaciones</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            )}
          </Row>

          {/* NOTAS */}
          <Row className="mt-3">
            <Col md={12}>
              <Form.Group>
                <Form.Label>Notas del Seguimiento</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  value={form.notas || ""}
                  onChange={(e) => handleChange("notas", e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* OPORTUNIDAD PERDIDA */}
          {reglas.mostrarOportunidadPerdida && (
            <Row className="mt-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Oportunidad Perdida</Form.Label>
                  <AsyncSelectERP
                    value={form.oportunidadPerdida}
                    loadOptionsApi={getOportunidadesPerdidas}
                    onChange={(val) => handleChange("oportunidadPerdida", val)}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Razón de oportunidad perdida</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={form.razonPerdida || ""}
                    onChange={(e) =>
                      handleChange("razonPerdida", e.target.value)
                    }
                  />
                </Form.Group>
              </Col>
            </Row>
          )}

          {/* MENSAJE GANADO */}
          {form.estatus === "Ganado" && (
            <div className="mt-3 text-success fw-bold">
              EL PROSPECTO SE CONVERTIRÁ EN CLIENTE
            </div>
          )}

          {/* PRÓXIMO SEGUIMIENTO */}
          {reglas.mostrarNext && (
            <Row className="mt-4">
              <Col md={12}>
                <h5>Datos Próximo Seguimiento</h5>
              </Col>

              <Col md={3}>
                <Form.Group>
                  <Form.Label>Usuario</Form.Label>
                  <AsyncSelectERP
                    value={form.nextUsuario}
                    loadOptionsApi={getAgentes}
                    additionalFilters={filtrosAgentes}
                    onChange={(val) => handleChange("nextUsuario", val)}
                  />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group>
                  <Form.Label>Seguimiento</Form.Label>
                  <AsyncSelectERP
                    value={form.nextSeguimiento}
                    loadOptionsApi={getTipoSeguimientos}
                    additionalFilters={[
                      {
                        property: "grupo_seguimiento",
                        value: "CL",
                      },
                    ]}
                    onChange={(val) => handleChange("nextSeguimiento", val)}
                  />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group>
                  <Form.Label>Fecha</Form.Label>
                  <Form.Control
                    type="date"
                    value={form.nextFecha || ""}
                    onChange={(e) => handleChange("nextFecha", e.target.value)}
                  />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group>
                  <Form.Label>Hora</Form.Label>
                  <Form.Control
                    type="time"
                    value={form.nextHora || ""}
                    onChange={(e) => handleChange("nextHora", e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
          )}
        </Form>
        <WdowConfirm
          show={confirmModal.show}
          onHide={() => setConfirmModal({ show: false })}
          onConfirm={async () => {
            try {
              setLoading(true);
              setConfirmModal({ show: false });

              const response = await onSubmit(confirmModal.payload);

              const actividadId = response?.actividad?.id || response?.id;

              // UPLOAD MINUTA
              if (form.archivoMinuta) {
                await uploadArchivo(
                  actividadId,
                  form.archivoMinuta,
                  form.archivoMinutaNombre,
                  "Minuta",
                );
              }

              // UPLOAD FPP
              if (form.archivoFPP) {
                await uploadArchivo(
                  actividadId,
                  form.archivoFPP,
                  form.archivoFPPNombre,
                  "FPP",
                );
              }

              toast.success("Seguimiento creado exitosamente");
            } catch (e) {
              console.error(e);
              toast.error("Error al crear el seguimiento");
              throw e;
            } finally {
              setLoading(false);
            }
          }}
          title={"Confirmar creación"}
          message={`¿Deseas crear el seguimiento?`}
          type={"confirm"}
          data={confirmModal.data}
        />
        <WdowConfirm
          show={confirmModalDelFile.show}
          onHide={() => setConfirmModalDelFile({ show: false })}
          onConfirm={async () => {
            try {
              const { field, archivoId } = confirmModalDelFile.payload || {};

              // SOLO si está en edición y hay archivo en BD
              if (isEditMode && archivoId) {
                await request(
                  `actividades/${record?.id}/remove-file/${archivoId}`,
                  {
                    method: "DELETE",
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem(
                        "authToken",
                      )}`,
                    },
                  },
                );
              }

              // Limpia el form
              setForm((prev) => ({
                ...prev,
                [field]: null,
                [`${field}Nombre`]: null,
                [`${field}Id`]: null,
              }));
            } catch (e) {
              console.error(e);
              throw e;
            } finally {
              setConfirmModalDelFile({ show: false });
            }
          }}
          title={"Eliminar archivo"}
          message={`¿Deseas eliminar este archivo?`}
          type={"confirm"}
        />
        {loading && (
          <div style={styles.overlay}>
            <div style={styles.spinnerContainer}>
              <Spinner label="Guardando…" />
              <div style={{ marginTop: 10, fontWeight: 500 }}>Guardando...</div>
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-between">
        <Button variant="outline-secondary" onClick={onHide} disabled={loading}>
          Cancelar
        </Button>

        <Button variant="success" onClick={handleSubmit} disabled={loading}>
          {isEditMode ? "Ejecutar Seguimiento" : "Crear Seguimiento"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
